import { useQuery } from '@tanstack/react-query'
import { apiFetch, getCallerAgentId, hasLiveApi } from '@/api/client'
import { isUnreachableApiError } from '@/api/unreachable'
import type { AgentNode } from '@/api/map/agent'
import { findEnrichedAccount, overlayNode } from '@/api/map/member'
import * as api from '@/data/api'
import { keys } from '@/api/hooks/shared/keys'

async function loadAccount(id: string) {
  if (!hasLiveApi()) return api.getAccount(id)
  try {
    const rootId = getCallerAgentId()!
    const [tree, node] = await Promise.all([
      apiFetch<AgentNode[]>(`/v1/agents/${rootId}/tree`),
      apiFetch<AgentNode>(`/v1/agents/${id}`),
    ])
    return findEnrichedAccount(overlayNode(tree, node), id)
  } catch (err) {
    if (isUnreachableApiError(err)) return null
    throw err
  }
}

export function useAccount(id: string | undefined) {
  return useQuery({
    queryKey: keys.account(id ?? ''),
    queryFn: () => loadAccount(id!),
    enabled: Boolean(id),
  })
}
